import React, { Component } from 'react';
import './css/Loading.css';
import loading from '../Rolling.svg';


class Loading extends Component {

	constructor(props) {
		
		super(props);
		this.state = {
			
		};
		// Bind Allow access by "this" into the function
		//this.submitForm = this.submitForm.bind(this);
	}

	render() {
		if(this.props.compNotReady.length > 0){
			return (
				<div className="d-flex align-items-center heiht100">
					<img src={loading} alt="Loading" className="mx-auto"></img>
				</div>
			);
		}else
			return "";
	}
}

export default Loading;



// WEBPACK FOOTER //
// ./src/Pages/Loading.js